import { render, staticRenderFns } from "./AddEditAttendeeDialog.vue?vue&type=template&id=0bf784b8"
import script from "./AddEditAttendeeDialog.vue?vue&type=script&lang=ts"
export * from "./AddEditAttendeeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports